import React from "react";
import "./ProjectAnimations.scss";

export function AppleFrameworksAnimation() {
  return (
    <div className="project-animation apple-animation" aria-hidden="true">
      <svg width="220" height="150" viewBox="0 0 220 150">
        {/* Apple Logo */}
        <g transform="translate(85,35) scale(0.5)">
          <path
            fill="#000"
            d="
M95.4 24.4c5.7-7 9.6-16.8 8.6-26.4-8.3.3-18.4 5.5-24.4 12.5-5.4
6.2-10.1 16.2-8.8 25.7 9.3.7 18.9-4.7 24.6-11.8z
M128 51.1c-12.9-.7-23.8 7.3-30 7.3-6.2 0-15.8-7.1-26-6.9-13.4.2-25.8
7.8-32.7 19.9-14 24.2-3.6 60 10 79.7 6.7 9.7 14.7 20.6 25.2 20.2
10.1-.4 13.9-6.5 26-6.5s15.5 6.5 26.3 6.3c10.9-.2 17.8-9.9
24.4-19.7 7.6-11.1 10.7-21.9 10.9-22.4-.2-.1-20.9-8-21.1-31.8
-.2-19.9 16.2-29.4 17-30-9.2-13.5-23.4-15-28-15.1z"
          />
        </g>

        {/* Orbiting frameworks */}
        <g className="orbit">
          <circle cx="110" cy="20" r="5" fill="#0ea5e9" />
          <circle cx="170" cy="75" r="5" fill="#22c55e" />
          <circle cx="110" cy="130" r="5" fill="#f59e0b" />
          <circle cx="50" cy="75" r="5" fill="#ef4444" />
        </g>
      </svg>
    </div>
  );
}

export function GithubAnimation() {
  return (
    <div className="project-animation github-animation" aria-hidden="true">
      <svg width="220" height="150" viewBox="0 0 220 150">
        {/* GitHub logo */}
        <path
          fill="#000"
          d="M110 25c-12 0-22 10-22 22 0 10 6 18 14 21
1 0 2-1 2-2v-4c-6 1-7-2-7-2-1-2-2-3-2-3-2-1 0-1 0-1
2 0 3 2 3 2 2 3 5 2 6 2 0-2 1-3 2-3-5-1-10-3-10-11
0-2 1-4 2-6 0-1-1-3 0-6 0 0 2-1 6 2a20 20 0 0111 0
c4-3 6-2 6-2 1 3 0 5 0 6 2 2 2 4 2 6 0 8-5 10-10 11
1 1 2 2 2 5v7c0 1 1 2 2 2 8-3 14-11 14-21
0-12-10-22-22-22z"
        />

        {/* Animated repo bars */}
        <g className="repo-bars">
          <rect x="70" y="95" width="12" height="20" />
          <rect x="95" y="95" width="12" height="20" />
          <rect x="120" y="95" width="12" height="20" />
          <rect x="145" y="95" width="12" height="20" />
        </g>
      </svg>
    </div>
  );
}

export function TmdbAnimation() {
  return (
    <div className="project-animation tmdb-animation" aria-hidden="true">
      <svg width="220" height="150" viewBox="0 0 220 150">
        {/* Phone */}
        <rect x="80" y="10" width="60" height="120" rx="12" fill="#111827" />

        {/* Screen */}
        <rect x="90" y="25" width="40" height="80" fill="#1f2937" />

        {/* Movie thumbnails */}
        <g className="movie-row">
          <rect x="95" y="35" width="15" height="20" fill="#ef4444" />
          <rect x="115" y="35" width="15" height="20" fill="#3b82f6" />
          <rect x="135" y="35" width="15" height="20" fill="#22c55e" />
        </g>

        {/* Play button */}
        <polygon points="108,75 108,90 120,82" fill="white" />
      </svg>
    </div>
  );
}

